<template>
  <div id="map"></div>
</template>

<script>
import { API_KEY } from "./API_KEY";
import { Loader } from "google-maps";
import { customers, sellers, baseUrl } from "../../../utils/userInfo";

const loader = new Loader(API_KEY);

export default {
  data() {
    return {
      map: null,
      locations: [
        ...customers.map((customer) => ({
          lat: customer.location.lat,
          lng: customer.location.lng,
          title: customer.name,
          color: "red",
          address: customer.walletAddress,
          info: customer.mapInfo,
          dashboard: customer.path,
        })),
        ...sellers.map((seller) => ({
          lat: seller.location.lat,
          lng: seller.location.lng,
          title: seller.name,
          color: "green",
          address: seller.walletAddress,
          info: seller.mapInfo,
          dashboard: seller.path,
        })),
        
      ],
    };
  },

  mounted() {
    loader.load().then(async (google) => {
      const bounds = new google.maps.LatLngBounds();

      // Fetch wallet balances for all locations
      await Promise.all(
        this.locations.map(async (loc) => {
          const balance = await this.getBalance(loc.address);
          loc.infoContent = `
      <div>
        ${loc.info}<br>
        Wallet Balance: ${balance} TESTFETs
        <br><br>
        <a onclick="window.location.href='#${loc.dashboard}'" style="
          display: inline-block;
          background-color: #2196F3;
          color: #FFFFFF;
          width: 100%;
          padding: 8px 16px;
          text-decoration: none;
          border-radius: 4px;
          font-weight: 500;
        ">
          <span style="color: white !important;">Dashboard</span>
        </a>
      </div>`;
        })
      );

      // Initialize the map
      const center = new google.maps.LatLng(48.313701, 8.085226);
      this.map = new google.maps.Map(document.getElementById("map"), {
        zoom: 13,
        center,
        scrollwheel: false,
        disableDefaultUI: true,
        zoomControl: true,
        styles: [
          {
            featureType: "water",
            stylers: [
              { saturation: 43 },
              { lightness: -11 },
              { hue: "#0088ff" },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              { hue: "#ff0000" },
              { saturation: -100 },
              { lightness: 99 },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#808080" }, { lightness: 54 }],
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [{ color: "#ece2d9" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#ccdca1" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#767676" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#ffffff" }],
          },
          { featureType: "poi", stylers: [{ visibility: "off" }] },
          {
            featureType: "landscape.natural",
            elementType: "geometry.fill",
            stylers: [{ visibility: "on" }, { color: "#b8cb93" }],
          },
          { featureType: "poi.park", stylers: [{ visibility: "on" }] },
          {
            featureType: "poi.sports_complex",
            stylers: [{ visibility: "on" }],
          },
          { featureType: "poi.medical", stylers: [{ visibility: "on" }] },
          {
            featureType: "poi.business",
            stylers: [{ visibility: "simplified" }],
          },
        ],
      });

      // Place markers with info windows
      this.locations.forEach((loc) => {
        const marker = new google.maps.Marker({
          position: { lat: loc.lat, lng: loc.lng },
          map: this.map,
          title: loc.title,
          icon: `https://maps.google.com/mapfiles/ms/icons/${loc.color}-dot.png`,
        });

        const infoWindow = new google.maps.InfoWindow({
          content: `<div><strong>${loc.title}</strong><br>${loc.infoContent}</div>`,
        });

        marker.addListener("click", () => {
          infoWindow.open(this.map, marker);
        });

        bounds.extend(marker.getPosition());
      });

      // Adjust the map to show all markers
      this.map.fitBounds(bounds);
    });
  },

  methods: {
   async getBalance(address) {
  try {
    const query = `
      query GetWalletBalance {
        balances(
          where: { address: { _eq: "${address}" } }
        ) {
          balance
          denom
        }
      }
    `;

    const response = await fetch(`${baseUrl}/graphql`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        query,
        operationName: "GetWalletBalance"
      })
    });

    const result = await response.json();

    const balances = result?.data?.balances || [];
    const fetBalance = balances.find(
      (coin) => coin.denom === "atestfet"
    );

    return fetBalance ? Number((fetBalance.balance)/1e18).toFixed(2).toString() : "0";
  } catch (error) {
    //console.error(`Failed to fetch balance for ${address}`, error);
    return "0";
  }
   }
},

};
</script>

<style>
#map {
  height: calc(100vh);
}

@media (max-width: 991px) {
  #map {
    margin-top: 0;
  }
}
</style>
